import React from "react";
import AntdForm, { FormProps as AntdFormProps } from "antd/es/form";

export type FormWrapperProps = AntdFormProps & {
  children?: React.ReactNode;
};

export const FormWrapper: React.FC<FormWrapperProps> = AntdForm;
